var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.99995C8 3.55812 8.35817 3.19995 8.8 3.19995H20.8C21.6834 3.19995 22.4 3.91652 22.4 4.79995V20.7999H9.6C9.15817 20.7999 8.8 20.4418 8.8 20C8.8 19.5581 9.15817 19.2 9.6 19.2H20.8V4.79995H8.8C8.35817 4.79995 8 4.44178 8 3.99995Z",
    fill: "#22428F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60001 3.19995H3.20001C2.31601 3.19995 1.60001 3.91595 1.60001 4.79995V20.7999H9.60001V3.19995ZM4.00001 7.19995C3.55841 7.19995 3.20001 6.84155 3.20001 6.39995C3.20001 5.95835 3.55841 5.59995 4.00001 5.59995C4.44161 5.59995 4.80001 5.95835 4.80001 6.39995C4.80001 6.84155 4.44161 7.19995 4.00001 7.19995ZM7.20001 7.19995C6.75841 7.19995 6.40001 6.84155 6.40001 6.39995C6.40001 5.95835 6.75841 5.59995 7.20001 5.59995C7.64161 5.59995 8.00001 5.95835 8.00001 6.39995C8.00001 6.84155 7.64161 7.19995 7.20001 7.19995ZM8.00001 10.4H3.20001V8.79995H8.00001V10.4Z",
    fill: "#22428F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconActive);
export default __webpack_public_path__ + "static/media/dashboard-icon-active.505265b4a301aca7f2c0123a8f9c633b.svg";
export { ForwardRef as ReactComponent };